import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { fetchVenueDetail, fetchGraphVenues, type VenueDetail, type GraphVenue } from "@/api/discover";
import { useArtistScope } from "@/lib/artistContext";
import PublicVenueFacts from "./PublicVenueFacts";
import { formatLocation } from "./discoverCopy";

/** Canonical detail remains reachable independently of the selected comparable graph. */
export default function PublicVenuePage() {
  const { globalVenueId } = useParams();
  const { selectedArtistId } = useArtistScope();
  const [detail, setDetail] = useState<VenueDetail | null>(null);
  const [graphVenue, setGraphVenue] = useState<GraphVenue | null>(null);
  const [error, setError] = useState(false);
  useEffect(() => {
    setDetail(null); setGraphVenue(null); setError(false);
    if (!globalVenueId || !selectedArtistId) return;
    let cancelled = false;
    fetchVenueDetail(globalVenueId, selectedArtistId).then(value => { if (!cancelled) setDetail(value); }).catch(() => { if (!cancelled) setError(true); });
    fetchGraphVenues(selectedArtistId).then(value => { if (!cancelled) setGraphVenue(value.venues.find(v => v.global_venue_id === globalVenueId) ?? null); }).catch(() => {});
    return () => { cancelled = true; };
  }, [globalVenueId, selectedArtistId]);
  if (error) return <p>Venue details couldn't be loaded.</p>;
  if (!detail) return <p>Loading venue details…</p>;
  return <main className="aa-page-shell max-w-3xl space-y-6"><header><h1 className="text-2xl font-semibold">{detail.name}</h1><p>{formatLocation([detail.city, detail.region, detail.country])}</p></header>{graphVenue && <section><h2 className="font-semibold">Why it fits</h2><p>Played by {graphVenue.comparable_artist_count} of your comparable artists</p><p>{graphVenue.comparable_artists.map(artist => artist.name).join(", ")}</p></section>}<PublicVenueFacts facts={detail.facts} /></main>;
}
